import PaymentResultPage from "./payment-result-page";

export default PaymentResultPage